(function(){
  var THROTTLE_MS = 250;
  var lastRun = 0;

  function moneyFromCents(cents){
    try{
      return (cents/100).toLocaleString(undefined,{style:'currency',currency:'USD'});
    }catch(e){
      var s = (cents/100).toFixed(2);
      return '$' + s;
    }
  }

  function render(el, cart){
    // SAFE_SKIPLINE_GUARDS: never touch quantity inputs or other UI
    if(!el || el.nodeType !== 1) return;

    if(!el) return;
    var threshold = parseInt(el.getAttribute('data-threshold') || '20000',10);
    // cart.items_subtotal_price is pre-discount in /cart.js
    var subtotal = (cart && typeof cart.items_subtotal_price === 'number') ? cart.items_subtotal_price : 0;
    var remaining = threshold - subtotal;

    var line2 = el.querySelector('.free-skipline__line2');
    if(!line2 || line2.nodeType !== 1) return;

    if(!line1) return;

    if(remaining > 0){
      line1.innerHTML = '<strong>USA:</strong> Add <strong>' + moneyFromCents(remaining) + '</strong> more to unlock';
    }else{
      line1.innerHTML = '<strong>USA:</strong> Unlocked:';
    }
  }



  function parseMoneyToCents(text){
    if(!text) return null;
    var t = String(text).trim();
    // remove currency symbols/letters
    t = t.replace(/[^0-9.,-]/g,'');
    if(!t) return null;
    // handle comma thousands
    if(t.indexOf(',')>-1 && t.indexOf('.')>-1){
      t = t.replace(/,/g,'');
    } else if(t.indexOf(',')>-1 && t.indexOf('.')===-1){
      // comma as decimal
      t = t.replace(/,/g,'.');
    }
    var n = parseFloat(t);
    if(isNaN(n)) return null;
    return Math.round(n*100);
  }

  function getSubtotalCentsFromDOM(){
    // Theme commonly renders cart subtotal into [data-subtotal]
    var el = document.querySelector('[data-subtotal]');
    if(el){
      var cents = parseMoneyToCents(el.textContent);
      if(typeof cents === 'number') return cents;
    }
    return null;
  }

  function updateAll(){
    // SKIPLINE_DEBUG
    try{console.log("[skipline] updateAll");}catch(e){}
    var now = Date.now();
    if(now - lastRun < THROTTLE_MS) return;
    lastRun = now;

    var els = document.querySelectorAll('[data-skipline]');
    if(!els || !els.length) return;
    var subtotalCents = getSubtotalCentsFromDOM();
    if(typeof subtotalCents !== 'number'){
      // fallback: try /cart.js (best-effort)
      fetch('/cart.js', {credentials:'same-origin'})
        .then(function(r){ return r.json(); })
        .then(function(cart){
          var cents = (cart && typeof cart.items_subtotal_price === 'number') ? cart.items_subtotal_price : null;
          els.forEach(function(el){ render(el, {items_subtotal_price: cents||0}); });
        })
        .catch(function(){ /* keep liquid fallback */ });
      return;
    }

    els.forEach(function(el){ render(el, {items_subtotal_price: subtotalCents}); });

  }



  function fetchCartSubtotalCents(cb){
    fetch('/cart.json', {credentials:'same-origin'})
      .then(function(r){ return r.json(); })
      .then(function(cart){
        var cents = (cart && typeof cart.items_subtotal_price === 'number') ? cart.items_subtotal_price : null;
        cb(cents);
      })
      .catch(function(){ cb(null); });
  }

  function burstCartSync(){
    // CART_JSON_BURST
    var runs = 0;
    var iv = setInterval(function(){
      runs += 1;
      fetchCartSubtotalCents(function(cents){
        if(typeof cents === 'number'){
          // update all skipline boxes using this subtotal
          var els = document.querySelectorAll('[data-skipline]');
          els.forEach(function(el){ render(el, {items_subtotal_price: cents}); });
        }
      });
      if(runs >= 6) clearInterval(iv);
    }, 300);
  }

  function burstUpdate(){
    // DUMB_RELIABLE_CART_POLL
    var times = 0;
    var iv = setInterval(function(){
      times += 1;
      updateAll();
      if(times >= 8) clearInterval(iv);
    }, 250);
  }

  // Initial
  document.addEventListener('DOMContentLoaded', function(){
    updateAll();

    // Common theme events (best-effort)
    document.addEventListener('cart:updated', updateAll);
    document.addEventListener('cart:refresh', updateAll);
    document.addEventListener('ajaxCart:afterCartLoad', updateAll);


    document.addEventListener('click', function(e){
      var t = e.target;
      if(!t) return;
      // Any cart-related controls
      if(t.closest && (t.closest('#CartDrawer') || t.closest('form[action*="/cart"]') || t.closest('[data-cart]'))){
        burstUpdate();
        burstCartSync();
      }
    }, true);


    // Also re-run after any add/change requests finish
    var _fetch = window.fetch;
    if(_fetch){
      window.fetch = function(){
        return _fetch.apply(this, arguments).then(function(res){
          try{
            var url = (arguments[0] && arguments[0].url) ? arguments[0].url : arguments[0];
            if (url != null) { url = String(url); }
            if(typeof url === 'string' && (url.indexOf('/cart/add')>-1 || url.indexOf('/cart/change')>-1 || url.indexOf('/cart/update')>-1)){
              setTimeout(updateAll, 50);
              setTimeout(burstCartSync, 80);
              setTimeout(updateAll, 400);
            }
          }catch(e){}
          return res;
        });
      };
    }



    // SUBTOTAL_BROADCAST: watch subtotal changes and update product page without refresh
    var lastSubtotal = null;
    function broadcastIfChanged(){
      var el = document.querySelector('[data-subtotal]');
      if(!el) return;
      var cents = parseMoneyToCents(el.textContent);
      if(typeof cents !== 'number') return;
      if(lastSubtotal === cents) return;
      lastSubtotal = cents;
      window.__CART_SUBTOTAL_CENTS = cents;
      try{ window.dispatchEvent(new Event('cart:subtotal')); }catch(e){}
      updateAll();
    }
    setInterval(broadcastIfChanged, 400);
    window.addEventListener('cart:subtotal', function(){ updateAll(); });


    // Fallback: observe DOM changes in cart drawer
    var drawer = document.getElementById('CartDrawer') || document.body;
    if(drawer && window.MutationObserver){
      var mo = new MutationObserver(function(){ updateAll(); });
      mo.observe(drawer, {subtree:true, childList:true, characterData:false});
    }
  });
})();
